import React, { useEffect, useState } from "react";

import { Collapse, ListItemButton } from "@mui/material";
import { List } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

import i18n from "i18n";
import { formatDateTodmy } from "helpers/Parsers";
import { capitalize, translateOrder } from "helpers/utils/utils_general";

import Step from "components/MainApp/atoms/Wizard/Step";
import Icon from "components/MainApp/atoms/Icon/icon";

import bluePencil from "assets/images/blue-pencil.svg";
import locationIcon from "assets/images/location-icon.svg";

import styles from "./PrepOrders.LoadPrepOrders.step3.module.scss";

export const RequestOrderStep3 = ({
  products,
  readTags,
  handleEditDest,
  handleEditProducts,
  order,
  handleSubmit,
  goBackFunc,
  isSimplified
}) => {
  const [open, setOpen] = useState(false);
  const [openMap, setOpenMap] = useState({});
  const [detailData, setDetailData] = useState([]);
  const iconStyle = { color: "rgb(60, 122, 245)" };
  const ExpandIcon = open ? ExpandLess : ExpandMore;

  const handleClick = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (order) {
      let data = [
        {
          title: i18n.t("reason").toUpperCase(),
          value: translateOrder(order.klass) || ""
        }
      ];

      if (order.klass === "SALE" || order.klass === "venta") {
        if (order.client) {
          data.push({
            title: i18n.t("client").toUpperCase(),
            value: order.client.name || order.client.label || ""
          });
        }
      }

      if (order.owner) {
        data.push({
          title: i18n.t("owner").toUpperCase(),
          value: order.owner.first_name || order.owner.label || ""
        });
      }

      if (order.notes) {
        data.push({
          title: i18n.t("description").toUpperCase(),
          value: order.notes || ""
        });
      }
      setDetailData(data);
    }
  }, [order]);

  const stepContent = (
    <div style={{ width: "100%" }}>
      <div className={styles["description-collapse-wrapper"]}>
        <ListItemButton
          onClick={handleClick}
          className={styles["request-order-step3-description"]}
        >
          <article>
            <div>
              <picture className={styles["icon-circle"]}>
                <img src={locationIcon} alt="location icon" />
              </picture>
              <h4>{i18n.t("step.description")}</h4>
            </div>
            <div className={styles["step3-header-actions"]}>
              <img
                src={bluePencil}
                alt="edit"
                className={styles["blue-pencil-icon"]}
              />
              <ExpandIcon className={styles["arrow-icon"]} style={iconStyle} />
            </div>
          </article>
        </ListItemButton>

        <Collapse
          in={open}
          timeout="auto"
          unmountOnExit
          className={styles["collapse-container"]}
        >
          <List component="div" disablePadding>
            {detailData.map(
              (item, index) =>
                item.value &&
                item.value !== "" && (
                  <div key={index} className={styles["step3-order-item"]}>
                    <div className={styles["step3-order-item-title"]}>
                      {item.title}
                    </div>
                    <div className={styles["step3-order-item-data"]}>
                      {item.value}
                    </div>
                  </div>
                )
            )}
          </List>
        </Collapse>
      </div>

      <div className={styles["step3-order-products-requested"]}>
        <div className={styles["step3-order-products-requested-title"]}>
          {i18n.t("requested.products")}
        </div>
        <div className={styles["step3-order-products-requested-quantity"]}>
          {products.length}
        </div>
        <div className={styles["step3-order-products-requested-total"]}>
          {readTags.length > 0
            ? readTags.length
            : products.reduce((acc, item) => acc + (item.units || 1), 0)}{" "}
          {i18n.t("units").toUpperCase()}
        </div>
      </div>

      <div className={styles["step3-order-items"]}>
        {products && products.length > 0 ? (
          products.map(product => {
            // Get the tags for this product
            const productTags =
              readTags?.filter(tag => tag.sku === product.sku) || [];
            const imageSrc =
              product.item_files?.[0]?.file_name ||
              product.image ||
              (product.item && product.item.item_files?.[0]?.file_name) ||
              null;

            const key = product.id || product.sku;
            const isOpen = !!openMap[key];
            const toggleOpen = () =>
              setOpenMap(prev => ({ ...prev, [key]: !prev[key] }));
            const ProductExpandIcon = isOpen ? ExpandLess : ExpandMore;

            return (
              <div
                key={product.sku || product.id}
                className={styles["step3-product-wrapper"]}
              >
                <div
                  className={styles["step3-product-header"]}
                  onClick={productTags.length > 0 ? toggleOpen : undefined}
                >
                  <div className={styles["step3-product-info"]}>
                    <div
                      className={`MuiListItemIcon-root ${styles["step3-product-image"]}`}
                    >
                      <img
                        src={imageSrc || ""}
                        alt={product.name || product.title}
                        style={{ height: 40 }}
                      />
                    </div>
                    <div className={styles["step3-product-text"]}>
                      <div className={styles["step3-product-title"]}>
                        {product.name || product.title}
                      </div>
                      <div className={styles["step3-product-sku"]}>
                        SKU {product.sku}
                      </div>
                    </div>
                  </div>
                  <div className={styles["step3-product-right"]}>
                    {productTags.length > 0 && isSimplified && (
                      <>
                        <div className={styles["step3-product-arrow"]}>
                          <ProductExpandIcon style={iconStyle} />
                        </div>
                        <div className={styles["step3-product-quantity"]}>
                          {productTags.length}{" "}
                          <span style={{ textTransform: "capitalize" }}>
                            {i18n.t("tags")}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {productTags.length > 0 && isSimplified && (
                  <Collapse in={isOpen} timeout="auto" unmountOnExit>
                    <div className={styles["step3-product-tags-table"]}>
                      <div className={styles["step3-table-header"]}>
                        <div className={styles["step3-col-epc"]}>EPC</div>
                        <div className={styles["step3-col-batch"]}>
                          {i18n.t("batch")}
                        </div>
                        <div className={styles["step3-col-expiration"]}>
                          {i18n.t("expiration")}
                        </div>
                      </div>
                      {productTags.map((tag, idx) => (
                        <div
                          key={tag.rfid || tag.tag || idx}
                          className={styles["step3-table-row"]}
                        >
                          <div className={styles["step3-col-epc"]}>
                            {tag.tag || tag.rfid}
                          </div>
                          <div className={styles["step3-col-batch"]}>
                            {tag.batch || tag.variables?.batch || "-"}
                          </div>
                          <div className={styles["step3-col-expiration"]}>
                            {tag.expiration_date || tag.variables?.expiration
                              ? formatDateTodmy(
                                  // Replace '-' with '/' to prevent the Date constructor from
                                  // interpreting the date in UTC and causing one-day offsets per time zone.
                                  new Date(
                                    (
                                      tag.expiration_date ||
                                      tag.variables?.expiration
                                    ).replace(/-/g, "/")
                                  )
                                )
                              : "-"}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Collapse>
                )}
              </div>
            );
          })
        ) : (
          <p>{i18n.t("no.items")}</p>
        )}
      </div>

      <div className={styles["step3-order-footer"]}>
        {isSimplified && (
          <div
            className={`${styles["cancel-button"]} ${styles["load-movement-items-button"]} ${styles["load-movement-items-clean"]}`}
            onClick={goBackFunc}
          >
            {i18n.t("go.back")}
          </div>
        )}
        <div
          className={`${styles["confirm-button"]} ${styles["load-movement-items-button"]} ${styles["load-movement-items-send"]}`}
          onClick={handleSubmit}
        >
          {i18n.t("confirm").toUpperCase()}
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles["request-order-step-three-container"]}>
      <Step
        title={i18n.t("check.data")}
        goBackFunc={isSimplified ? goBackFunc : null}
        backIcon={"new"}
        content={stepContent}
      ></Step>
    </div>
  );
};

export default RequestOrderStep3;
